import React, { Component } from "react";

import styles from "./SiftingLogo.module.scss";
import screen from "../../../media/images/screenwhite.png";

class SiftingLogo extends Component {
  render() {
    return (
      <div
        id={styles.screen}
        style={{
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundImage: `url(${screen})`
        }}
      />
    );
  }
}

export default SiftingLogo;
